module.exports = __webpack_public_path__ + "img/60c25dcd85ace9.59066405.f5a14519.png";